import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

// Wrapper de /liftlogic/component-attribute-defs (catálogo dinámico de atributos
// de componentes). Sin estado: cada método retorna la data del axios.
//
// El catálogo de atributos es GLOBAL (liftlogic super-tenant → tenantId NULL).
// Decisión 2026-06-19: no hay override por-tenant (YAGNI).
// El hook no pasa ?tenantId (correcto — el backend scopea por TenantProvider ambiente).
const useComponentAttributeDefsApi = () => {
  const list = useCallback(async () => {
    const { data } = await axios.get(`${API_PATH}/liftlogic/component-attribute-defs`, {
      headers: authHeaders(),
    });
    return data; // { defs: [...] }
  }, []);

  const create = useCallback(async (payload) => {
    const { data } = await axios.post(`${API_PATH}/liftlogic/component-attribute-defs`, payload, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const update = useCallback(async (id, payload) => {
    const { data } = await axios.put(
      `${API_PATH}/liftlogic/component-attribute-defs/${id}`,
      payload,
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const remove = useCallback(async (id) => {
    const { data } = await axios.delete(`${API_PATH}/liftlogic/component-attribute-defs/${id}`, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  return useMemo(() => ({ list, create, update, remove }), [list, create, update, remove]);
};

export default useComponentAttributeDefsApi;
